import Vue from 'vue';
import Router from 'vue-router';
import qs from 'qs';
import { getUnionId, getBYDUnionId } from '@/api/api';
import { isWeiXin, isMobile } from '@/common/ts/common';
import SyActivityDemo from './views/samples';
import SBHJJBM20250708 from '@/views/20250708SBHJJBM';
import JZGS20250715 from '@/views/20250715JZGS';
import GSDS20250716 from '@/views/20250716GSDS';
import JJRW20250801 from '@/views/20250801JJRW';
import YUCHAO20281031 from '@/views/20251031YUCHAO';
import TYSY20250113 from '@/views/20250113TYSY';

import MSKT20260209 from '@/views/20260209MSKT';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: () => import('@/views/HelloWorld.vue'),
    },
    // Demo展示
    SyActivityDemo,
    // 2025上游书博会记者报名活动
    SBHJJBM20250708,
    // 重庆市好记者讲好故事
    JZGS20250715,
    // 第二届“电靓巴渝和美乡村”故事大赛
    GSDS20250716,
    // 2024十大重庆经济年度人物评选
    JJRW20250801,
    // 渝超传情——探寻巴渝体育文化新韵
    YUCHAO20281031,
    // home
    TYSY20250113,
    // 2026“马”上开团新春特别策划
    MSKT20260209,
    {
      path: '*',
      name: 'not-found',
      component: () => import('@/views/NotFound/Home.vue'),
    },
    {
      path: '/code',
      name: 'code',
      component: () => import('@/components/next/MessageLogin.vue'),
    },
    {
      path: '/BindPhone',
      name: 'BindPhone',
      component: () => import('@/components/next/BindPhone.vue'),
    },
  ],
  // 跳转后回到顶部
  scrollBehavior(to, from, savedPosition): any {
    return (
      savedPosition || {
        x: 0,
        y: 0,
      }
    );
  },
});

router.beforeEach(async (to: any, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // 以下操作均在微信环境中生效
  if (!isWeiXin()) {
    next();
    return;
  }
  const { code } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  // 控制微信授权是否启用
  if (to.meta.customWeChatAuth) {
    console.log('第三方公众号, 不默认拉取用户信息');
  } else if (code && !localStorage.getItem('unionid')) {
    console.log('request wx user info');
    let res: any = '';
    if (window.location.href.indexOf('BYD0621') > -1) {
      res = await getBYDUnionId({ code });
    } else {
      res = await getUnionId({ code });
    }
    if (res.code === 200) {
      console.log('res.data878738475o3874', res.data);
      window.localStorage.setItem('unionid', res.data.openId);
      window.localStorage.setItem('nickname', res.data.nickname);
      window.localStorage.setItem('headimgurl', res.data.headimgurl);
      // 应将用户微信信息整体存入localStorage
      localStorage.setItem('syWeChatUserInfo', JSON.stringify(res.data));
    } else {
      console.log('清理过期的code');
      // !query中清理过期code字段, 防止用户分享携带有自己的code的页面给其他人，导致无法进行授权登录的状况
      const queries = to.query;
      let strings = '';
      Object.keys(queries).forEach((item: any) => {
        if (item !== 'code') {
          strings += `${item}=${queries[item]}&`;
        }
      });
      strings = strings.slice(0, strings.length - 1);
      location.href = `${window.location.origin}${window.location.pathname}?${strings}`;
    }
  } else {
    console.log('例外');
  }
  next();
});

router.onError((error) => {
  // PC微信解析一个异步组件异常时错误收集
  if (isWeiXin() && !isMobile()) {
    const el = document.createElement('p');
    el.innerHTML = '请复制链接在Chrome, QQ, 360极速/安全等现代浏览器中打开';
    el.style.textAlign = 'center';
    document.body.innerHTML = '';
    document.body.appendChild(el);
  }
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = (router as Router & { history: any }).history.pending
    .fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router;
